import { useEffect, useState } from 'react'

const MOBILE_WIDTH = 800

const isMobileWidth = () => window.innerWidth <= MOBILE_WIDTH

/**
 * Checks if the screen is mobile by checking the width of the screen.
 * Code taken from https://stackoverflow.com/q/39435395.
 * There are libraries to check for mobile devices, but it seems like they might not be fully reliable.
 * Since we intend to be on mobile eventually, we should be able to use this as a temporary solution.
 * @returns true if the screen is mobile, false otherwise
 */
const useCheckMobileScreen = () => {
  // Stores the derived boolean, not the raw width: a resize that doesn't cross
  // MOBILE_WIDTH must not re-render every consumer.
  const [isMobile, setIsMobile] = useState(isMobileWidth)

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsMobile(isMobileWidth())
    }

    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  return isMobile
}

export default useCheckMobileScreen
